import { Autocomplete } from "stimulus-autocomplete"

export default class extends Autocomplete {
  static values = { queryParam: { type: String, default: "term" } }

  connect() {
    super.connect()

    if (this.selectedOption) {
      this.commit(this.selectedOption, false)
    }
  }

  commit(selected, focus = true) {
    if (selected.getAttribute("aria-disabled") === "true") return

    if (selected instanceof HTMLAnchorElement) {
      selected.click()
      this.close()
      return
    }

    const textValue = selected.getAttribute("data-autocomplete-label") || selected.textContent.trim()
    const value = selected.getAttribute("data-autocomplete-value") || textValue
    this.inputTarget.value = textValue

    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = value
      this.hiddenTarget.dispatchEvent(new Event("input"))
      this.hiddenTarget.dispatchEvent(new Event("change"))
    } else {
      this.inputTarget.value = value
    }

    if (focus) {
      this.inputTarget.focus()
    }
    this.hideAndRemoveOptions()

    if (focus) {
      this.element.dispatchEvent(
        new CustomEvent("autocomplete.change", {
          bubbles: true,
          detail: { value, textValue, selected }
        })
      )
    }
  }
}
